import { generateUseUseSettings } from '../../hooks/generateUseUsingSettings';
import { walnutCommercialFrontend } from './Commercial/settings';
import { walnutNeoFrontend } from './Neo/settings';
import { walnutAtbFrontend } from './Atb/settings';

export const useUsingWalnutSettings = generateUseUseSettings([
  walnutCommercialFrontend,
  walnutNeoFrontend,
  walnutAtbFrontend,
]);
